import React, { Component } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

// components
import Gradient from 'mapping/legends/Gradient';

const baseString = 'vra-retractable-legend';
class RetractableLegend extends Component {

  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
  }

  onClick() {
    this.setState({open: !this.state.open});
  }

  render() {
    const { className, colors, displayValues, highLabel, lowLabel, title } = this.props;

    const classString = classNames({
      [`${baseString}`]: true,
      'vra-legend': true,
      [`${className}`]: !!className
    });

    const titleClassString = classNames({
      [`${baseString}__title`]: true,
      'vra-legend__title': true
    });

    const highLabelClassString = classNames({
      [`${baseString}__label`]: true,
      [`${baseString}__label--high`]: true
    });

    const lowLabelClassString = classNames({
      [`${baseString}__label`]: true,
      'vra-legend__label': true,
      [`${baseString}__label--low`]: true
    });

    const gradientClassString = classNames({
      [`${baseString}__gradient`]: true,
      'vra-legend__gradient': true
    });

    const displayColors = colors.slice(0, displayValues.length);
    return (
      <section className={classString} onClick={() => this.onClick()}>
        { this.props.isRetractable && (
          <span className={`${baseString}__arrow`}>
            {this.state.open ? '>>' : '<<'}
          </span>
        )
        }
        {this.state.open && title && <header className={titleClassString}>{title}</header>}
        <figcaption className={highLabelClassString}>
          {this.state.open && highLabel}
        </figcaption>
        <figcaption className={lowLabelClassString}>
          {lowLabel}
        </figcaption>
        <div className={`${baseString}__gradient-wrapper`}>
          <Gradient
            className={gradientClassString}
            colors={displayColors}
            displayValues={this.state.open ? displayValues : []}
          />
        </div>
      </section>
    );
  }
}
RetractableLegend.propTypes = {
  className: PropTypes.string,
  colors: PropTypes.array.isRequired,
  displayValues: PropTypes.array.isRequired,
  highLabel: PropTypes.string,
  isRetractable: PropTypes.bool.isRequired,
  lowLabel: PropTypes.string,
  title: PropTypes.string
};
export default RetractableLegend;
